import React, { useState } from "react";
import { Tabs, Tab, Box, Typography } from "@mui/material";
import StatusLineIcon from "../../assets/icons/StatusLineSymbol";
import SymbolIcon from "../../assets/icons/SymbolIcon";
import TradeIcon from "../../assets/icons/Trade";
import StatusLineSettings from "./statusLineSettings";
import TradingSettings from "./tradingSettings";

type Props = {
    viewKey: string;
    symbolTabContent: React.ReactNode;
    initialTab?: number;
};

const CommonChartSettingsTabs = ({ viewKey, symbolTabContent, initialTab = 0 }: Props) => {
    const [tab, setTab] = useState(initialTab);

    const tabStyle = {
        padding: '6px 0px 6px 20px',
        alignItems: "start",
        justifyContent: 'center',
        textTransform: "capitalize",
        color: (theme: any) => theme.palette.text.primary,
        borderRadius: '4px',
        '&.Mui-selected': {
            color: (theme: any) => theme.palette.text.primary,
            backgroundColor: (theme: any) => theme.palette.action.selected,
            '& .tab-label': {
                fontWeight: 600,
            },
        },
    };

    return (
        <Box sx={{ display: "flex", flex: 1 }}>
            <Tabs
                orientation="vertical"
                value={tab}
                onChange={(_, newValue) => setTab(newValue)}
                sx={{
                    borderRight: 1,
                    borderColor: "divider",
                    minWidth: 200,
                    paddingTop: "6px",
                }}
            >
                <Tab
                    value={0}
                    sx={tabStyle}
                    label={
                        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <SymbolIcon sx={{ width: 28, height: 28 }} />
                            <Typography fontSize="14px" className="tab-label" fontWeight={400}>
                                Symbol
                            </Typography>
                        </span>
                    }
                />
                <Tab
                    value={1}
                    sx={tabStyle}
                    label={
                        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <StatusLineIcon sx={{ width: 28, height: 28 }} />
                            <Typography fontSize="14px" className="tab-label" fontWeight={400}>
                                Status Line
                            </Typography>
                        </span>
                    }
                />
                <Tab
                    value={2}
                    sx={tabStyle}
                    label={
                        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <TradeIcon sx={{ width: 28, height: 28 }} />
                            <Typography fontSize="14px" className="tab-label" fontWeight={400}>
                                Trading
                            </Typography>
                        </span>
                    }
                />
            </Tabs>

            <Box sx={{ flex: 1, padding: 2 }}>
                {tab === 0 && <>{symbolTabContent}</>}
                {tab === 1 && <StatusLineSettings viewKey={viewKey} />}
                {tab === 2 && <TradingSettings viewKey={viewKey} />}
            </Box>
        </Box>
    );
};

export default CommonChartSettingsTabs;